import React from 'react'
import StyledSmText from '../../../common/components/styledSmText/StyledSmText'
import StyledH3Heading from '../../../common/components/styledH3Heading/StyledH3Heading'
import StyledH2Heading from '../../../common/components/styledH2Heading/StyledH2Heading'
import StyledMdText from '../../../common/components/styledMdText/StyledMdText'
import Button from '../../../components/button/Button'
import LinkedButton from '../../../components/linkedButton/LinkedButton'
import { Link } from 'react-router-dom'

const CommunitySection = () => {
  return (
    <div className='w-[90%] py-20 lg:w-[80%] h-full'>
      <div className='flex flex-col items-center justify-between h-full gap-10 lg:gap-0 lg:flex-row'>
        <div className='flex flex-col gap-5 w-[95%] lg:w-[65%]'>
          <div className='text-center'>
            <StyledSmText fontColor="text-gray">COMMUNITY-OWNED AND OPERATED</StyledSmText>
          </div>
          <div>
            <StyledH3Heading fontColor="text-gradient">Enter a Universe of Connected Services.</StyledH3Heading>
          </div>
          <div>
            <StyledMdText fontColor="text-white">HopeLedger is Pakistan's first decentralized crowdfunding platform on blockchain, connecting over 265 apps and services. With $63B+ in digital assets, HopeLedger uses the Inter-Blockchain Communication protocol (IBC) to enable seamless asset and data exchange across various platforms.</StyledMdText>
          </div>
          <div className='flex w-full gap-5 pt-5'>
            <div className='w-[50%] lg:w-[30%]'>
              <Button fontColor="text-black" variant="button-gradient">Learn</Button>
            </div>
            <Link to="/projects" className='w-[50%] lg:w-[30%]'>
              <Button target="true" fontColor="text-white">Explore Projects</Button>
            </Link>
          </div>
        </div>
        <div className='flex flex-row lg:flex-col justify-between lg:gap-20 h-full lg:h-[70%] lg:items-end w-[95%] lg:w-[35%]'>
          <div className='w-max'>
            <div>
              <StyledH2Heading fontColor="text-gradient">265+</StyledH2Heading>
            </div>
            <div className='text-right'>
              <StyledMdText fontColor="text-white">Apps & services</StyledMdText>
            </div>
          </div>
          <div className='w-max'>
            <div>
              <StyledH2Heading fontColor="text-gradient">$63B+</StyledH2Heading>
            </div>
            <div className='text-right'>
              <StyledMdText fontColor="text-white">Digital assets</StyledMdText>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CommunitySection
